import { ConcreteEncodable } from "./ConcreteEncodable";

import { ManualNettingEventImplEncoder } from "../../encoder/ManualNettingEventImplEncoder";

import * as CubiqTS from "../../index";
import { ManualNettingEvent } from "../ManualNettingEvent";

export class ManualNettingEventImpl extends ConcreteEncodable implements ManualNettingEvent {
  public static enType: string = "com.bcdfx.model.event.ManualNettingEventImpl";

  /*FID=1*/
  public hasPortfolioId: boolean;
  /*FID=2*/
  public portfolioId: string;
  /*FID=3*/
  public orderIds: Array<string> | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = ManualNettingEventImplEncoder.Instance;
    this.setEncodableType(ManualNettingEventImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "ManualNettingEventImpl[" +
      "hasPortfolioId=" +
      this.hasPortfolioId +
      "portfolioId=" +
      this.portfolioId +
      "orderIds=" +
      this.orderIds +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
